"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSafeAreaMarginBoth = exports.getSafeAreaPaddingBoth = exports.getBottomSafeAreaMargin = exports.getTopSafeAreaMargin = exports.getBottomSafeAreaPadding = exports.getTopSafeAreaPadding = exports.multilineEllipses = exports.singleLineEllipses = void 0;

var react_1 = require("@emotion/react");

exports.singleLineEllipses = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n"])));

var multilineEllipses = function multilineEllipses(line) {
  return react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n"])), line);
};

exports.multilineEllipses = multilineEllipses; // iPhone X SafeArea

var getTopSafeAreaPadding = function getTopSafeAreaPadding(topPadding) {
  return react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-top: calc(constant(safe-area-inset-top) + ", "px);\n  padding-top: calc(env(safe-area-inset-top) + ", "px);\n"])), topPadding || 0, topPadding || 0);
};

exports.getTopSafeAreaPadding = getTopSafeAreaPadding;

var getBottomSafeAreaPadding = function getBottomSafeAreaPadding(bottomPadding) {
  return react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-bottom: calc(\n    constant(safe-area-inset-bottom) + ", "px\n  );\n  padding-bottom: calc(env(safe-area-inset-bottom) + ", "px);\n"])), bottomPadding || 0, bottomPadding || 0);
};

exports.getBottomSafeAreaPadding = getBottomSafeAreaPadding;

var getTopSafeAreaMargin = function getTopSafeAreaMargin(topMargin) {
  return react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: calc(constant(safe-area-inset-top) + ", "px);\n  margin-top: calc(env(safe-area-inset-top) + ", "px);\n"])), topMargin || 0, topMargin || 0);
};

exports.getTopSafeAreaMargin = getTopSafeAreaMargin;

var getBottomSafeAreaMargin = function getBottomSafeAreaMargin(bottomMargin) {
  return react_1.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: calc(\n    constant(safe-area-inset-bottom) + ", "px\n  );\n  margin-bottom: calc(env(safe-area-inset-bottom) + ", "px);\n"])), bottomMargin || 0, bottomMargin || 0);
};

exports.getBottomSafeAreaMargin = getBottomSafeAreaMargin;

var getSafeAreaPaddingBoth = function getSafeAreaPaddingBoth(bottomPadding, topPadding) {
  return react_1.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding-top: calc(constant(safe-area-inset-bottom) + ", "px);\n  padding-top: calc(env(safe-area-inset-bottom) + ", "px);\n  padding-bottom: calc(\n    constant(safe-area-inset-bottom) + ", "px\n  );\n  padding-bottom: calc(env(safe-area-inset-bottom) + ", "px);\n"])), topPadding || 0, topPadding || 0, bottomPadding || 0, bottomPadding || 0);
};

exports.getSafeAreaPaddingBoth = getSafeAreaPaddingBoth;

var getSafeAreaMarginBoth = function getSafeAreaMarginBoth(bottomMargin, topMargin) {
  return react_1.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-top: calc(constant(safe-area-inset-bottom) + ", "px);\n  margin-top: calc(env(safe-area-inset-bottom) + ", "px);\n  margin-bottom: calc(\n    constant(safe-area-inset-bottom) + ", "px\n  );\n  margin-bottom: calc(env(safe-area-inset-bottom) + ", "px);\n"])), topMargin || 0, topMargin || 0, bottomMargin || 0, bottomMargin || 0);
};

exports.getSafeAreaMarginBoth = getSafeAreaMarginBoth;